module.exports = __webpack_public_path__ + "fonts/firacode-bold.3a18280.woff";